import { useMemo, useState } from "react";
import { INTERNAL_ROUTES } from "../../../../constants/routes";
import { getThemeIconLogo, getThemeLogo } from "../../../../helpers";
import { useThemeSwitch } from "../../../../theme";
import { getCurrentSelectedTenant } from "../../../../utils";

type NavLogoProps = {
  navigateTo: (route: string, openInNewTab?: boolean) => void;
  thumbLogoUrl?: string;
  addMargin?: boolean;
  /** Render the compact logo. Tenant logos are unaffected. */
  iconOnly?: boolean;
  /** data-testid applied to the logo button. */
  testId?: string;
};

export const NavLogo = ({
  navigateTo,
  thumbLogoUrl,
  addMargin,
  iconOnly = false,
  testId = "nav-logo-button",
}: NavLogoProps) => {
  const { appliedTheme } = useThemeSwitch();
  const themeLogo = useMemo(
    () => (iconOnly ? getThemeIconLogo(appliedTheme) : getThemeLogo(appliedTheme)),
    [appliedTheme, iconOnly]
  );

  const [hasImageError, setHasImageError] = useState(false);

  const logoSrc = thumbLogoUrl && !hasImageError ? thumbLogoUrl : themeLogo;
  const isThemeIcon = iconOnly && logoSrc === themeLogo;
  const currentTenant = getCurrentSelectedTenant();

  return (
    <button
      type="button"
      aria-label="Go to dashboard"
      data-testid={testId}
      onClick={() => navigateTo(INTERNAL_ROUTES.Learn.route)}
      style={{
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <img
        alt={`${currentTenant} Logo`}
        src={logoSrc}
        className="nav-logo"
        style={{
          height: "auto",
          width: isThemeIcon ? "32px" : "100px",
          maxHeight: "40px",
          objectFit: "contain",
          margin: addMargin ? "8px 0" : isThemeIcon ? 0 : "0 16px 0 0",
        }}
        onError={() => setHasImageError(true)}
      />
    </button>
  );
};
